/**
 * Parse an ISO-8601 datetime string into epoch milliseconds.
 *
 *   - `undefined` input → `undefined` output (caller treats as "field omitted").
 *   - Non-string input → `'invalid'` sentinel (caller rejects the request).
 *   - String that `Date.parse` cannot make sense of → `'invalid'`.
 *   - Anything else → epoch ms number.
 *
 * Used by inbound CSMS payload parsers (SetChargingProfile's
 * `validFrom`/`validTo`, recurringStart, etc.) where the spec lets a
 * field be optional but, when present, REQUIRES a parseable date.
 * The three-state return lets the caller distinguish "absent" from
 * "present but garbage" without throwing.
 */
export function parseDateTime(raw: unknown): number | undefined | 'invalid' {
  if (raw === undefined) return undefined;
  if (typeof raw !== 'string') return 'invalid';
  const ms = Date.parse(raw);
  return Number.isFinite(ms) ? ms : 'invalid';
}
